import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Design pulled me in, and ever since, I've been creating,
              experimenting, and growing as a visual storyteller. 🎨
              <br />
              <br />I work with tools like
              <i>
                <b className="purple"> Figma, Photoshop, Illustrator, </b>
                  and
                <b className="purple"> Procreate </b>
              </i>
                to bring ideas to life - whether it's designing seamless UX/UI experiences or crafting digital art.
              <br />
              <br />
              My interests lie in &nbsp;
              <i>
                <b className="purple">building intuitive, user-centered digital products </b>
                  and
                <b className="purple"> creating visuals </b>
                that not only look good but feel right. {" "}
              </i>
              <br />
              <br />
              Whenever I can, I explore my artistic side through illustration, 
              digital painting, and experimenting with new creative techniques.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/barbora-mitzová/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/senkora.art"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
